import { render, staticRenderFns } from "./TaskChoice.vue?vue&type=template&id=c9c0535a&"
import script from "./TaskChoice.vue?vue&type=script&lang=js&"
export * from "./TaskChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports